import MovieDetailsContent from './MovieDetailsContent';

export default MovieDetailsContent;